export type pdpType = {
    userId: string;
    pdpInfo: pdpInfoType[];
    suppressMessage?: boolean;
};

export type pdpInfoType = {
    itemId: string;
    itemPrice: number;
    count: number;
    lastView: number;
};

export const UNIQUE_PDP_VIEW_COUNT = 25;
export const TWO_WEEKS_PERIOD = 1000 * 60 * 60 * 24 * 7 * 2; //1000ms/s * 60s/min * 60min/hr * 24hr/day * 7days/week * 2weeks
export const STORAGE_KEY_PDP_VISITS = 'recentSourcingPdpList';
export const MEDIAN_ITEM_VALUE_INDEX = 12;
export const SOURCING_MIN_PRICE = 5000;
